<template>
        <div class="warp">
            <!-- 面包屑 -->
             <breadcrumb :back="true" :crubList="[{name:'金融合作伙伴管理'},{name:'会员风采管理',goback:true},{name:'新增会员风采'}]" :title="'新增会员风采'"/>
            <!-- 表单 -->
            <div class="box">
                <div class="forms">
                    <div class="child">
                        <div class="name"><span>*</span>会员风采标题：</div>
                        <div class="content">
                          <el-input v-model="sendInfo.title" maxlength="20" placeholder="限20字"></el-input>
                        </div>
                    </div>
                    <div class="error" v-if="errors['sendInfo.title']">错误提示：{{errors['sendInfo.title']}}</div>
                    <div class="child">
                        <div class="name"><span>*</span>来源：</div>
                        <div class="content">
                           <el-input v-model="sendInfo.source" maxlength="20" placeholder="限20字"></el-input>
                        </div>
                        
                    </div>
                    <div class="error" v-if="errors['sendInfo.source']">错误提示：{{errors['sendInfo.source']}}</div>
                    <div class="child">
                        <div class="name">适用地区：</div>
                        <div class="content">
                           <!-- <el-input v-model="sendInfo.provinceId" maxlength="20" placeholder="限20字"></el-input> -->
                           <!-- <el-cascader
                              v-model="sendInfo.provinceId"
                              :options="province" :props="{label:'name',value:'id',children:'sysAddressVoList'}"></el-cascader> -->
                            <el-select v-model="sendInfo.provinceId" placeholder="请选择">
                              <el-option v-for="(item,idx) in province" :key="idx" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </div>
                        
                    </div>
                    <div class="child">
                        <div class="name"><span>*</span>会员风采详情：</div>
                        <div class="content super_prv">
                          <wangEnduit v-model="sendInfo.content" :quill-index="0" my-editor="editor" :height="500" :upload="handleUploadEditor" />
                          <el-button type="primary" class="ml10" @click="onPrivew" plain size="small">预览</el-button>
                        </div>
                    </div>
                    <div class="error" v-if="errors['sendInfo.content']">错误提示：{{errors['sendInfo.content']}}</div>
                    <div class="child">
                        <div class="name"><span>*</span>附件：</div>
                        <div class="content" >
                          <upLoadFiles
                          v-model="sendInfo.fileList"
                          :action="'/backstage/annex/files'"
                          :size="50"
                          :accept="'application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/msword'"
                          />
                        </div>
                    </div>
                    <div class="error" v-if="errors['sendInfo.fileList']">错误提示：{{errors['sendInfo.fileList']}}</div>

                    <div class="singleBtn">
                      <el-button type="primary" size="small" @click="submit">提交审核并发布</el-button>
                    </div>
                </div>
            </div>
            <el-dialog title="预览" :visible.sync="dialogVisible" width="50%">
            <el-tabs type="border-card">
                    <el-tab-pane>
                        <span slot="label">pc</span>
                        <div v-html="sendInfo.content" class="prv_content isPc"></div>
                    </el-tab-pane>
                    <el-tab-pane>
                        <span slot="label">移动端</span>
                        <div v-html="sendInfo.content" class="prv_content isApp"></div>
                    </el-tab-pane>
            </el-tabs>
                
            </el-dialog>
        </div>
</template>

<script>
import {API} from "@/axios/config";
import breadcrumb from '../../components/breadcrumb';
import upLoadFiles from '../../components/upLoadFiles';
import wangEnduit from '../../components/Editor/index';
import {getDict} from "@/axios";
export default {
    components:{
        breadcrumb,
        upLoadFiles,
        wangEnduit
    },
    data(){
        return{
          dialogVisible:false,
            statusList: [],//服务类型
			id:'',
            sendInfo:{
                id:void 0,// ，编辑时必传
                announcementType: 4, // 类型:1=通知公告，2=协会动态，3=附加资料
                title: void 0,
                source: void 0,// 来源
                content: void 0,// 内容
                provinceId: void 0, // 省份
                fileList: []
            },
            province:[],
			dict:{
				currentPage:1,
				direction:null,
				pageSize:10,
				parentId :1069409909080064,
				property:null,
        
			}
        }
    },
    computed: {
        errors() {
            return this.$vuerify.$errors // 错误信息会在 $vuerify.$errors 内体现
        }
    },
	created() {
		this.getProvince()
		if(this.$route.params.id){
		    this.id=this.$route.params.id;
		 	this.sendInfo.id=this.$route.params.id;
			this.getDetail();
		}
		
	},
    vuerify: {
		'sendInfo.title':{
		    test:function(val){
		        if(val){
		            return true;
		        }else{
		            return false;
		        }
		    },
		    message:'请填写会员风采标题'
		},
		'sendInfo.source':{
		    test:function(val){
		        if(val){
		            return true;
		        }else{
		            return false;
		        }
		    },
		    message:'填写来源'
		},
        'sendInfo.content':{
            test:function(val){
                if(val){
                    return true;
                }else{
                    return false;
                }
            },
            message:'填写会员风采内容'
        }
    },
    methods:{
      async getProvince(){
        const {code,data,msg} = await  this.$axiosz.get('/backstage/sysAddress/100000')
        if(code === 200) this.province = data || []
      },
      onPrivew(){
          if(!this.sendInfo.content || !this.sendInfo.content.trim()){
            this.$message.info('暂无内容不能预览')
            return 
          }
          this.dialogVisible = true
        },
		getDetail(){
			this.$axiosc.get('/backstage/announcement/findAnnouncementDetails/'+this.id).then((r)=>{
			    if(r.code==200){
              const param = {
                id:this.id,// ，编辑时必传
                announcementType: 4, // 类型:1=通知公告，2=协会动态，3=附加资料
                title: r.data.title,
                source: r.data.source,// 来源
                content: r.data.content,// 内容
                fileList: r.data.fileList || []
              }
					
					this.sendInfo=param;
			    }else{
			        this.$alert(r.msg)
			    }
			})
		},
        //提交
        submit:function(){
            this.$vuerify.clear();
            if(this.$vuerify.check()){
              this.$axioscBody.post('/backstage/announcement/saveAnnouncement',this.sendInfo).then((r)=>{
                if(r.code==200){
                  this.$message({
                    type: 'success',
                    message: r.msg
                  });
                  this.$router.back();
                }else{
                  this.$alert(r.msg);
                }
              })
            }
        },
        /** 富文本编辑器图片上传 */
    handleUploadEditor(file, callback) {
      const that = this
      const formData = new window.FormData()
      formData.append('file', file)
      // 上传 todu
      that.$axiosz.post(API.UploadsService + "backstage/annex/file", formData).then(res => {
        const {data,code,msg} = res
        if(code === 200){
        const { frontPath, filePath,fileName } = data
        const param = { ...data }
        param.name = fileName
        param.url = frontPath + filePath
        callback(param)
        }
      }).catch(e => {
        // that.$message.info('上传失败')
        that.$alert('上传失败')
        console.log(e)
      })
    },
    }
}
</script>

<style lang="scss" scoped>
.warp{
    height:95.5%;
     overflow: hidden;
    .box{
        
        padding:20px 0 ;
        height:calc(94% - 50px);
     overflow-x: hidden;
     overflow-y: auto;
        .forms{
            max-width: 750px;
            margin: auto;
            .child{
                .content{
                    flex: 1;
					.el-textarea{
						width: 100% !important;
					}
                }
				/deep/ .el-select{
					width: 100% !important;
				}
				
				.name{
					width: 150px !important;
					text-align: right;
				}
            }
			.hint{
				padding-left: 100px;
			}
			.singleBtn{
				text-align: center;
			}
			.error{
				padding-left: 100px;
			}
        }
    }
}
</style>